import type {
  CollectionActions,
  CollectionStateSlice,
  Reference,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import type { SuperuserGroupsCollection } from './superuser-groups.types';
import { transformGroup } from '../groups/groups.transformers';

export function superuserGroupsReducer(
  state: CollectionStateSlice<SuperuserGroupsCollection> = {},
  action: CollectionActions<SuperuserGroupsCollection>,
): CollectionStateSlice<SuperuserGroupsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'superuserGroups') {
        const { result, ref, order } = action.payload;

        return mergeDocuments<SuperuserGroupsCollection>(
          state,
          transformIntoDocuments(result.groups, transformGroup),
          order,
          ref,
        );
      }
      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'superuserGroups') {
        const { result, ref } = action.payload;

        return mergeWebsocketDocuments<SuperuserGroupsCollection>(
          state,
          transformIntoDocuments([result], transformGroup),
          ref,
        );
      }
      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'superuserGroups') {
        const { ref, result } = action.payload;
        return mergeWebsocketDocuments(
          state,
          transformIntoDocuments([result], transformGroup),
          ref,
        );
      }
      return state;
    }

    case 'API_DELETE_SUCCESS': {
      if (action.payload.type === 'superuserGroups') {
        const { originalDocument, ref } = action.payload;
        return removeDocumentById<SuperuserGroupsCollection>(
          ref,
          state,
          originalDocument.id,
        );
      }

      return state;
    }

    case 'WS_MESSAGE': {
      if (action.payload.type === 'resource') {
        const { data, toUserId } = action.payload;
        if (
          data.payload.updateType === 'group.update' &&
          data.payload.payload.group
        ) {
          const ref: Reference<SuperuserGroupsCollection> = {
            path: {
              collection: 'superuserGroups',
              authUid: toUserId,
            },
          };

          return mergeWebsocketDocuments<SuperuserGroupsCollection>(
            state,
            transformIntoDocuments(
              [data.payload.payload.group],
              transformGroup,
            ),
            ref,
          );
        }
      }
      return state;
    }

    default:
      return state;
  }
}
